/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaHeatmap model module.
 * @module model/AqaHeatmap
 * @version v0
 */
export default class AqaHeatmap {
  /**
   * Constructs a new <code>AqaHeatmap</code>.
   * @alias module:model/AqaHeatmap
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaHeatmap</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaHeatmap} obj Optional instance to populate.
   * @return {module:model/AqaHeatmap} The populated <code>AqaHeatmap</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaHeatmap();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('tableId'))
        obj.tableId = ApiClient.convertToType(data['tableId'], 'String');
      if (data.hasOwnProperty('width'))
        obj.width = ApiClient.convertToType(data['width'], 'Number');
      if (data.hasOwnProperty('height'))
        obj.height = ApiClient.convertToType(data['height'], 'Number');
      if (data.hasOwnProperty('originallyRequestedWidth'))
        obj.originallyRequestedWidth = ApiClient.convertToType(data['originallyRequestedWidth'], 'Number');
      if (data.hasOwnProperty('originallyRequestedHeight'))
        obj.originallyRequestedHeight = ApiClient.convertToType(data['originallyRequestedHeight'], 'Number');
      if (data.hasOwnProperty('orientation'))
        obj.orientation = ApiClient.convertToType(data['orientation'], 'String');
      if (data.hasOwnProperty('horizontalOffset'))
        obj.horizontalOffset = ApiClient.convertToType(data['horizontalOffset'], 'Number');
      if (data.hasOwnProperty('horizontalPostPad'))
        obj.horizontalPostPad = ApiClient.convertToType(data['horizontalPostPad'], 'Number');
      if (data.hasOwnProperty('verticalOffset'))
        obj.verticalOffset = ApiClient.convertToType(data['verticalOffset'], 'Number');
      if (data.hasOwnProperty('verticalPostPad'))
        obj.verticalPostPad = ApiClient.convertToType(data['verticalPostPad'], 'Number');
      if (data.hasOwnProperty('timestamp'))
        obj.timestamp = ApiClient.convertToType(data['timestamp'], 'Number');
      if (data.hasOwnProperty('dateColours'))
        obj.dateColours = ApiClient.convertToType(data['dateColours'], 'String');
      if (data.hasOwnProperty('overallColours'))
        obj.overallColours = ApiClient.convertToType(data['overallColours'], 'String');
      if (data.hasOwnProperty('populationColours'))
        obj.populationColours = ApiClient.convertToType(data['populationColours'], 'String');
      if (data.hasOwnProperty('uniquenessColours'))
        obj.uniquenessColours = ApiClient.convertToType(data['uniquenessColours'], 'String');
      if (data.hasOwnProperty('numberColours'))
        obj.numberColours = ApiClient.convertToType(data['numberColours'], 'String');
      if (data.hasOwnProperty('stringColours'))
        obj.stringColours = ApiClient.convertToType(data['stringColours'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
AqaHeatmap.prototype.id = undefined;

/**
 * @member {String} tableId
 */
AqaHeatmap.prototype.tableId = undefined;

/**
 * @member {Number} width
 */
AqaHeatmap.prototype.width = undefined;

/**
 * @member {Number} height
 */
AqaHeatmap.prototype.height = undefined;

/**
 * @member {Number} originallyRequestedWidth
 */
AqaHeatmap.prototype.originallyRequestedWidth = undefined;

/**
 * @member {Number} originallyRequestedHeight
 */
AqaHeatmap.prototype.originallyRequestedHeight = undefined;

/**
 * Allowed values for the <code>orientation</code> property.
 * @enum {String}
 * @readonly
 */
AqaHeatmap.OrientationEnum = {
  /**
   * value: "column"
   * @const
   */
  column: "column",

  /**
   * value: "row"
   * @const
   */
  row: "row"
};
/**
 * @member {module:model/AqaHeatmap.OrientationEnum} orientation
 */
AqaHeatmap.prototype.orientation = undefined;

/**
 * @member {Number} horizontalOffset
 */
AqaHeatmap.prototype.horizontalOffset = undefined;

/**
 * @member {Number} horizontalPostPad
 */
AqaHeatmap.prototype.horizontalPostPad = undefined;

/**
 * @member {Number} verticalOffset
 */
AqaHeatmap.prototype.verticalOffset = undefined;

/**
 * @member {Number} verticalPostPad
 */
AqaHeatmap.prototype.verticalPostPad = undefined;

/**
 * @member {Number} timestamp
 */
AqaHeatmap.prototype.timestamp = undefined;

/**
 * @member {String} dateColours
 */
AqaHeatmap.prototype.dateColours = undefined;

/**
 * @member {String} overallColours
 */
AqaHeatmap.prototype.overallColours = undefined;

/**
 * @member {String} populationColours
 */
AqaHeatmap.prototype.populationColours = undefined;

/**
 * @member {String} uniquenessColours
 */
AqaHeatmap.prototype.uniquenessColours = undefined;

/**
 * @member {String} numberColours
 */
AqaHeatmap.prototype.numberColours = undefined;

/**
 * @member {String} stringColours
 */
AqaHeatmap.prototype.stringColours = undefined;

